import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lnr_lang") || "ro");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "ro" ? "en" : "ro";
      localStorage.setItem("lnr_lang", next);
      return next;
    });
  }, []);

  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
